// extracted by mini-css-extract-plugin
export default {"panel":"panel_panel__YSJkP","padding":"panel_padding__UVwpM","numberContainer":"panel_numberContainer__ju1-w","number":"panel_number__8batk","content":"panel_content__PvKWd"};